import React from 'react';

import { ArticleCenter, ArticleLeft, ArticleRight, ArticleProps } from './components';

const Components = {
  left: ArticleLeft,
  right: ArticleRight,
  center: ArticleCenter,
} as const;

type Props = ArticleProps & {
  alignment: keyof typeof Components;
};

export const Article: React.FC<Props> = ({ alignment, ...articleProps }) => {
  const ArticleComponent = Components[alignment];

  return <ArticleComponent {...articleProps} />;
};
